export enum RiskAssessmentActionTypes {
  //all RiskAssessment
  sendResponse = 'sendResponse/all',
  sendResponseSuccess = 'sendResponseSuccess/all',
  sendResponseFail = 'sendResponseFail/all',
}
